/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { isEmpty } from 'lodash'

import type { UserProfile } from '@modules/ui-types'
import type { PaymentDetails } from '@modules/billing-api/customTypes'

export function isTrialUser(profile: UserProfile): boolean {
  return profile.inTrial
}

export function isTrialNotStartedUser({ inTrial, trials }: UserProfile): boolean {
  return inTrial && !trials.length
}

export function isNotPayingUser(profile: UserProfile, paymentDetails?: PaymentDetails): boolean {
  return (
    !profile.invoicable &&
    !profile.is_paying &&
    isEmpty(paymentDetails?.recurly_billing_info) &&
    paymentDetails?.external_billing_info?.card == null
  )
}

export function isTrialOrNotPayingUser(
  profile: UserProfile,
  paymentDetails?: PaymentDetails,
): boolean {
  if (isTrialUser(profile)) {
    // always show for trial users
    return true
  }

  // if a user is not in trial and is not yet paying (for whatever reason), we want to show this
  // but only if they don't already have CC details added
  return isNotPayingUser(profile, paymentDetails)
}
